import { BUSCAR_OPCOES_FILTROS_ADESAO_PONTOS } from '../../actions/types'

const initialState = undefined;

const estadoInicial = {
    empresas: []
}

export default function reducerBuscarOpcoesFiltrosAdesaoPontos (state = estadoInicial, action = initialState) {
  switch (action.type) {
    case BUSCAR_OPCOES_FILTROS_ADESAO_PONTOS: {
      const opcoesFiltros = action.payload.data;

      if (opcoesFiltros) {
        return opcoesFiltros
      }
      return estadoInicial
    }

    default: {
      return state
    }
  }
}
